<template>
  <div class="searchResult">
    <div class="title">
      <van-nav-bar
          v-if="status_title == 1"
          title="待开方中"
          left-arrow
          @click-left="onClickLeft"
      />
      <van-nav-bar
          v-if="status_title == 2"
          title="处方审核中"
          left-arrow
          @click-left="onClickLeft"
      />
      <van-nav-bar
          v-if="status_title == 3"
          title="审核通过"
          left-arrow
          @click-left="onClickLeft"
      />
      <van-nav-bar
          v-if="status_title == 4"
          title="审核不通过"
          left-arrow
          @click-left="onClickLeft"
      />
      <van-nav-bar
          v-if="status_title == 5"
          title="开方超时"
          left-arrow
          @click-left="onClickLeft"
      />
    </div>
    <div class="content">
      <div v-if="status_u == 3 && styleColor && !listPrecription.type" class="remind">
        <span>可点击下方:"再次联系该医生",我们将为您开处方</span>
      </div>
      <div v-if="status_title == 4" class="remind">
        <span>审核不通过原因： {{ listPrecription.invalidInfo }}</span>
      </div>
      <van-list v-model="loading" :finished="finished">
        <div class="list_conts">
          <ul class="list_cont">
            <li>
              <div class="line" />
              <div class="icon_cont">
                <span>
                  <!-- 已问诊  -->
                  <img src="../../icons/succ.png" />
                  <!-- <img v-show="status==2" src="../../icons/fail.png"> -->
                </span>
                <!-- 代开方 开方超时 -->
                <span>
                  <img v-if="status_u == 1" src="../../icons/waitpre.png" />
                  <img v-if="status_u == 5" src="../../icons/succ.png" />
                  <img v-if="status_u == 3" src="../../icons/fail.png" />
                  <!-- ststus模拟状态5 -->
                </span>
                <!-- 待审核 -->
                <span>
                  <img
                      v-if="auditStatus_u == 1"
                      src="../../icons/waitpre.png"
                  />
                  <img
                      v-else-if="auditStatus_u == 2"
                      src="../../icons/succ.png"
                  />
                  <img v-else src="../../icons/wait.png" />
                </span>
                <!-- 审核失败 已审核 -->
                <span>
                  <img v-if="auditStatus_us == 2" src="../../icons/succ.png" />
                  <img
                      v-else-if="auditStatus_us == 3"
                      src="../../icons/fail.png"
                  />
                  <img v-else src="../../icons/wait.png" />
                </span>
              </div>
              <div class="list_cont_status">
                <a>已问诊</a>
                <a v-if="status_u == 3">开方超时</a>
                <a v-if="status_u == 1">待开方</a>
                <a v-if="status_u == 5">待开方</a>
                <a>待审核</a>
                <a v-if="auditStatus_us == 2">已审核</a>
                <a v-else-if="auditStatus_us == 3">审核驳回</a>
                <a v-else>已审核</a>
              </div>
              <div class="remindnew">{{ detailTitle }}</div>
            </li>
            <!-- <li v-if="status_title==1" class="patinfo">
            <p><span>姓名</span><span>男 22岁</span></p>
            <p><span>医生信息:</span><span>张仲景</span></p>
            <p><span>问诊时间:</span><span>2019-09-08 15:37</span></p>
            <p><span>过敏史:</span><span>否</span></p>
            </li>-->
          </ul>
        </div>
        <!-- <Prescription v-if="status_title!=1" :list-pre="listPre" /> -->
        <!-- 契约锁 -->
        <PrescriptionImg
          :list="listPrecription"
          v-if="
            (listPrecription.signType === 20 || listPrecription.signType === 40 || listPrecription.signType === 60) && listPrecription.prescriptionImage
          "
        />
        <!-- 契约锁 -->
        <div v-else>
          <Prescription
              v-if="
              auditStatus_u === 1 ||
                auditStatus_us === 2 ||
                auditStatus_us === 3
            "
              :list="listPrecription"
          />
          <div
              v-else-if="status_u === 1 || status_u === 5 || status_u === 3"
              class="detailconts"
          >
            <ul class="detailconts_list">
              <li class="patinfo">
                <p>
                  <span>{{ listPrecription.patientName }}</span>
                  <span
                  >{{ sexTrans(listPrecription.patientSex) }}
                    {{ listPrecription.patientAge }}</span
                  >
                </p>
                <p>
                  <span>医生信息:</span>
                  <span>{{ listPrecription.physicianName }}</span>
                </p>
                <p>
                  <span>问诊时间:</span>
                  <span>{{ listPrecription.createTime }}</span>
                </p>
                <p class="allergy">
                  <span>过敏史:</span>
                  <span>{{
                      allergyTrans(listPrecription.ext)
                    }}</span>
                </p>
                <p class="allergy" v-if="listPrecription.ext">
                  <span>病情描述:</span>
                  <span>{{ listPrecription.ext.mainSuit }}</span>
                </p>
                <p class="allergy" v-if="listPrecription.ext">
                  <span>诊断结果:</span>
                  <span>{{ listPrecription.ext.diagnosis }}</span>
                </p>
                <p class="allergy" v-if="list.ext && (list.ext.prescriptionDetail && Array.isArray(list.ext.prescriptionDetail)||list.ext.prescriptionTCMDetail && Array.isArray(list.ext.prescriptionTCMDetail))">
                  <span>用药申请:</span>
                  <span v-if="list.medicineType===0">
                <p class="no-top" v-for="(item, idx) in list.ext.prescriptionDetail" :key="idx">
                  {{ (item.commonName ? item.commonName : item.productName) + ' x' + item.quantity }}
                </p>
                </span>
                <span v-else>
                    <p class="no-top" v-for="(item, idx) in list.ext.prescriptionTCMDetail" :key="idx">
                      {{ (item.commonName ? item.commonName : item.productName) + ' ' + item.quantity+'g' }}
                    </p>
                  </span>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <!-- <Prescription v-else :list="listPrecription" /> -->
      </van-list>
      <!-- 再次联系该医生 -->
      <div class="contbutton">
        <van-button
            v-if="styleColor && !listPrecription.type"
            v-online-click="goContactDoctor"
            type="info"
        >再次联系该医生</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import Prescription from '../../components/Prescription'
import { getPreDetail, getPreGuid, getMessageListReaded } from '../../api/index'
import { againInquiry, getSign, goInquiry } from '../../api/video'
import { toast } from '../../components/Toast'
import { getCookie } from '@/utils/auth'
import PrescriptionImg from '../prescriptionImg'
import { initLog } from "@/utils/"

export default {
  components: { Prescription, PrescriptionImg },
  data() {
    return {
      listPrecription: {}, // 传递给组件的处方信息
      showPre: true,
      status_u: '',
      auditStatus: '',
      selectIcon: false,
      finished: true, // 数据全部加载完成
      loading: false, // 加载状态是否结束,为true表示正在加载中
      listPre: '',
      // 代开方
      auditStatus_u: '', // 待审核状态
      auditStatus_us: '', // 已审核状态
      status_title: '', // title的文字 1为待开方   2为处方审核  3为审核通过 4为审核不通过
      messageGuid: '',
      // 再次联系该医生
      roomNumber: '', // 房间号
      inquiryRecordGuid: '', // 问诊记录guid
      physicianGuid: '', // 医生guid
      // 获取app需要的三个字段
      userId: '', // 用户ID
      appId: '', // 视频应用的APPID
      userSign: '', // 视频应用的密钥
      detailTitle: '',
      styleColor: false
    }
  },
  computed: {
    getNewsGuid() {
      return this.$store.state.app.prescriptionGuid
    },
    sexTrans() {
      return function(oldsex) {
        const sex = oldsex === 1 ? '男' : '女'
        return sex
      }
    },
    allergyTrans() {
      let allergySymptom = ''
      return function(allergy) {
        if (allergy) {
          allergySymptom = allergy.allergySymptom === 1 ? '无' : allergy.allergySymptomExplain
        } else {
          allergySymptom = '无'
        }

        return allergySymptom
      }
    }
  },
  watch: {
    getNewsGuid(curVal, oldVal) {
      console.log(
          'page:waitprenews; object:watch-getNewsGuid; curVal:',
          curVal,
          'this.messageGuid:',
          this.messageGuid
      )
      if (curVal === this.messageGuid) {
        this.init()
      }
    }
  },
  async created() {
    // 隐藏底部栏
    window.location.href = 'protocol://action/hideBottomTab'
    console.log(
        'page:waitprenews; object:created; window.location.href:',
        window.location.href
    )
    console.log(
        'page:waitprenews; object:created; this.$route.query:',
        this.$route.query
    )
    // this.listPre = this.$route.query.guid
    this.init()
    window.handleWIFIstate = data => {
      getSign({})
          .then(resApp => {
            const { roomNumber, userSign, employeeId } = resApp.result
            againInquiry({
              roomNumber,
              inquiryRecordGuid: this.inquiryRecordGuid,
              physicianGuid: this.physicianGuid
            })
                .then(res => {
                  this.$store.commit('setRoomNumber', roomNumber)
                  this.$store.commit('setInquiryRecordGuid', res.result)
                  const client = getCookie('native_client') || ''
                  if (client == 'android' || client == 'ios' || client == 'pad') {
                    window.location.href = `protocol://action/app_trtc?userid=${employeeId}&usersig=${userSign}&roomid=${roomNumber}&pageType=2`
                  } else {
                    window.location.href = `protocol://action/app_trtc?userid=${employeeId}&usersig=${userSign}&roomid=${roomNumber}`
                  }
                })
                .catch(res => {
                  toast(res.msg)
                })
          })
          .catch(res => {
            toast(res.msg)
          })
    }
  },
  mounted() {},
  methods: {
    formatTimeStamp(date) {
      return (
          Date.parse(new Date(date)) ||
          Date.parse(new Date(date.replace(/-/g, '/')))
      )
    },
    async init() {
      try {
        console.log(
            'page:waitprenews; object:init; this.getGuid:',
            this.getGuid
        )
        // console.log('获取appGuid', this.$store.state.app.prescriptionGuid)
        // 将app弹出的本条消息设置为已读  this.$store.state.app.prescriptionGuid
        // await getMessageListReaded({ guid: this.getGuid() })
        await getMessageListReaded({ guid: this.$route.query.guid })

        // const resapp = await getPreGuid({ guid: 'r0OEPEX0l1F3ZJz0REg8dQZrupu5HcZQ' })
        // 获取app页面的url中的guid,转化为messageGuid，
        const resapp = await getPreGuid({ guid: this.$route.query.guid })

        this.messageGuid = resapp.messageGuid
        // this.messageGuid = this.$route.query.guid

        this.listPre = this.messageGuid
        console.log('this.messageGuid', this.messageGuid)
        // 用messageGuid，请求处方详情
        const res = await getPreDetail({ guid: this.messageGuid })

        if (res.ext&&typeof res.ext === String) {
          res.ext = JSON.parse(res.ext);
        }

        if (res.unPrescribeReason&&typeof res.unPrescribeReason === String) {
          res.unPrescribeReason = JSON.parse(res.unPrescribeReason);
        }

        this.listPrecription = res // 传递给组件
        this.$store.commit('setPatientGuid', this.listPrecription.patientGuid)
        if (
            new Date(
                this.formatTimeStamp(this.listPrecription.invalidTime)
            ).toDateString() === new Date().toDateString()
        ) {
          // 今天
          console.log('当天')
          this.styleColor = true
        } else if (
            new Date(this.formatTimeStamp(this.listPrecription.invalidTime)) <
            new Date()
        ) {
          // 之前
          this.styleColor = false
          console.log(
              new Date(this.formatTimeStamp(this.listPrecription.invalidTime))
                  .toISOString()
                  .slice(0, 10)
          )
        }
        console.log(
            'page:waitprenews; object:init; this.listPrecription(传递给组件):',
            this.listPrecription
        )
        // 获取再次联系该医生数据
        this.roomNumber = res.orderNo
        this.inquiryRecordGuid = res.inquiryGuid
        this.physicianGuid = res.physicianGuid
        // ......结束
        // const res = await getPreDetail({ guid: this.$route.query.guid || this.messageGuid })
        // console.log('ressss', res)
        this.status_u = res.status
        if (res.status === 2) {
          let { ext, unPrescribeReason } = this.res.result;

          this.$router.replace({
            name: 'preclose',
            // query: { item: this.res }
            params: { item: this.res.result, ext: ext = {}, unPrescribeReason: unPrescribeReason = [] }
          })
          // this.$router.push({
          //   path: 'preclose',
          //   query: { item: this.res.result }
          // })
        }
        // else if(this.status_u === 3){

        // }
        // this.listPre = this.$route.query.guid
        if (res.status === 1) {
          this.status_title = 1
          // 头部显示 代开方(分 代开方，开方超时)
        } else if (res.status === 3) {
          this.status_title = 5
        }
        if (res.auditStatus >= 1) {
          this.status_u = 5
        }
        if (res.auditStatus === 1) {
          this.auditStatus_u = 1
          this.status_title = 2
        }
        if (res.auditStatus === 2) {
          this.auditStatus_u = 2
          this.auditStatus_us = 2
          this.status_title = 3
        }
        if (res.auditStatus === 3) {
          this.auditStatus_u = 2
          this.auditStatus_us = 3
          this.status_title = 4
        }

        if (this.status_u === 1) {
          this.detailTitle = '医生开具处方后，我们将为您推送处方消息'
        } else if (this.status_u === 2) {
          this.detailTitle =
              '医生取消了开具电子处方，建议患者线下就诊以便对病情有更好的评估，如有需要可重新问诊'
        } else if (this.status_u === 3) {
          this.detailTitle = '订单已超时'
        } else if (this.status_u === 0) {
          this.detailTitle = '您已取消问诊'
        } else if (this.auditStatus_u === 1) {
          this.detailTitle = '药师审核处方后，我们将为您推送审核结果'
        } else if (this.auditStatus_us === 3) {
          this.detailTitle = '您的处方审核未通过'
        } else if (this.auditStatus_u === 2) {
          this.detailTitle = '您的处方已通过审核'
        }
        // this.status = res.status
        // this.auditStatus = res.auditStatus
        console.log('res.detail', res)
      } catch (error) {
        console.log(error)
      }
    },
    onClickLeft() {
      // window.location.href = 'protocol://action/finish/'
      this.$router.push({ path: 'home' })
    },
    // 获取url中guid的方法
    getGuid() {
      // this.appguid = window.location.href.split('?')[1].split('=')[1]
      this.appguid = this.$route.query.guid
      return this.appguid
    },
    async goContactDoctor() {
      try {
        this.setLog({
          message: "再次联系该医生成功",
          type: "/waitprenews"
        })
        window.location.href = `protocol://action/prepare_app_trtc`
        // const resagain = await againInquiry({ roomNumber: this.roomNumber, inquiryRecordGuid: this.inquiryRecordGuid, physicianGuid: this.physicianGuid })
        // console.log('再次联系该医生接口返回值', resagain)
        // if (resagain.code === 0) {
        //   toast(resagain.result)
        //   // 请求userId,roomNumber，userSin给app
        //   const resApp = await getSign({})
        //   const { roomNumber, userSign, employeeId } = resApp.result
        //   if (resApp.code === 0) {
        //     window.location.href = `protocol://action/app_trtc?userid=${employeeId}&usersig=${userSign}&roomid=${roomNumber}`
        //     // goInquiry({
        //     //   roomNumber,
        //     //   patientGuid: this.patientGuid
        //     // }).then(res => {

        //     // }).catch(res => {
        //     //   console.log(res)
        //     // })
        //   } else {
        //     toast(resApp.msg)
        //   }
        //   console.log('获取后端返回的app的三个字段', resApp)
        //   console.log('直接调视频')
        // }
      } catch (error) {
        this.setLog({
          message: "再次联系该医生失败",
          type: "/waitprenews"
        })
        toast(error.msg || error.message)
      }
    },
    /**
     * @description: 加log日志
     * @param {Object} json对象
     * @return:
     */
      setLog(msg) {
      $hyjkLoggerSdk.info(initLog(msg), "PATIENTH5");
    },
  }
}
</script>
<style scoped>
/* 调整第一个li样式 */
.detailconts {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 140px;
}
.detailconts_list {
  width: 345px;
  height: 140px;
  background: #fff;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.detailconts_list li {
  width: 345px;
  height: 133px;
  text-align: center;
}
.detailconts_list .patinfo {
  text-align: left;
  width: 285px;
  padding-bottom: 10px;
}
.patinfo p {
  height: 30px;
  font-size: 15px;
  margin-top: 0;
  margin-bottom: 0;
  overflow: hidden;
}
.patinfo p.allergy {
  height: auto;
}
.patinfo p:nth-of-type(1) {
  margin-top: 10px;
}
.patinfo p span:nth-of-type(1) {
  margin-right: 5px;
}
.patinfo p:nth-of-type(1) span:nth-of-type(1) {
  font-size: 17px;
  font-weight: 600;
}
.patinfo p:nth-of-type(1) span:nth-of-type(2) {
  color: #999999;
  font-size: 12px;
}
.patinfo p:nth-of-type(n + 2) span:nth-of-type(1) {
  font-size: 15px;
  font-weight: 400;
  color: #999999;
}
.patinfo p:nth-of-type(n + 2) span:nth-of-type(2) {
  font-size: 15px;
  font-weight: 400;
  color: #333333;
}
.list_conts {
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}
.list_cont {
  width: 345px;
  background: #fff;
  border-radius: 14px 14px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.list_cont li {
  width: 345px;
  height: 142px;
  text-align: center;
}
.icon_cont {
  width: 285px;
  margin: 0 30px;
  display: flex;
  justify-content: space-between;
  height: 25px;
  line-height: 25px;
  position: absolute;
  top: 25px;
}
.icon_cont span {
  width: 25px;
  height: 25px;
  display: inline-block;
}
.list_cont_status {
  width: 285px;
  margin: 0 30px;
  position: absolute;
  top: 65px;
}
.icon_cont span img {
  width: 25px;
  height: 25px;
}
.list_cont li:nth-of-type(1) {
  position: relative;
  border-bottom: 1px solid #e1e1e1;
}
.list_conts .line {
  border-bottom: 1px dashed #d8d8d8;
  width: 100%;
  width: 285px;
  margin: 0 30px;
  position: absolute;
  top: 37.5px;
}
.remindnew {
  width: 285px;
  height: auto;
  font-size: 12px;
  color: #999999;
  background: #f7f7f7;
  line-height: 20px;
  padding: 1px 0;
  box-sizing: border-box;
  text-align: center;
  font-weight: 400;
  margin-top: 15px;
  margin-left: 30px;
  margin-right: 30px;
  position: absolute;
  top: 80px;
}
.searchResult {
  background: #f7f7f7;
  min-height: 100vh;
  display: flex;
  padding-top: 74px;
  flex-direction: column;
}
/* 9.10新增 */

.searchResult /deep/.van-nav-bar {
  color: #666666;
  height: 64px;
}
.van-nav-bar .van-icon {
  color: #666666;
  width: 10px;
  height: 18px;
  vertical-align: super;
}
.van-nav-bar__title {
  font-family: 'Microsoft YaHei', 微软雅黑;
  font-size: 18px;
  font-weight: 550;
  color: rgba(51, 51, 51, 1);
  line-height: 64px;
}
.title {
  position: fixed;
  background: #fff;
  width: 375px;
  height: 64px;
  color: #666666;
  top: 0;
  z-index: 999;
}
.van-hairline--bottom::after {
  border-bottom-width: 0;
}

.remind {
  width: 375px;
  background: #ffe9e8;
  color: #ff3b30;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  line-height: 28px;
  padding: 0 10px;
  z-index: 10;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.searchResult /deep/.patinfo {
  text-align: left;
  width: 285px;
}
.patinfo p {
  height: 30px;
  font-size: 15px;
  margin-top: 0;
  margin-bottom: 0;
  margin: 5px 0;
}
.patinfo p:nth-of-type(1) {
  margin-top: 10px;
}
.patinfo p span:nth-of-type(1) {
  margin-right: 5px;
}
.patinfo p:not(:first-child) span:nth-of-type(1) {
  display: inline-block;
  width: 70px;
  float: left;
}
.patinfo p:nth-of-type(1) span:nth-of-type(1) {
  font-size: 17px;
  font-weight: 600;
  display: flex;
}
.patinfo p:nth-of-type(1) span:nth-of-type(2) {
  color: #999999;
  font-size: 12px;
}
.patinfo p:nth-of-type(n + 2) span:nth-of-type(1) {
  font-size: 15px;
  font-weight: 400;
  color: #999999;
}
.patinfo p:nth-of-type(n + 2) span:nth-of-type(2) {
  font-size: 15px;
  font-weight: 400;
  color: #333333;
}
.list_cont_status {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
.list_cont_status a {
  font-size: 14px;
  color: #666666;
  font-weight: 400;
}
.contbutton {
  height: 60px;
  background: #f7f7f7;
  padding-bottom: 10px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.van-button--normal {
  width: 345px;
  height: 49px;
  margin: 0 10px;
  border-radius: 24px;
  margin-top: 10px;
}
.van-button__text {
  font-size: 18px;
  font-weight: 500;
}
.content {
  flex: 1;
  position: relative;
  overflow: scroll;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
}
.van-list {
  margin-bottom: 0px;
  flex: 1;
}
.no-top {
  margin-top: 0 !important;
  min-height: 30px !important;
  height: unset !important;
}
</style>
